/* eslint-disable import/prefer-default-export */

export const UPDATE_EDUCATIONAL_CONTENTS = 'UPDATE_EDUCATIONAL_CONTENTS';
export const UPDATE_EDUCATIONAL_CONTENT = 'UPDATE_EDUCATIONAL_CONTENT';
